var map = {
	"./bg.jpg": "29a8",
	"./card1.png": "50e3",
	"./code.png": "cc8c",
	"./gift.png": "edd0",
	"./logo.png": "f30c",
	"./logo1.jpg": "f331",
	"./logo2.jpg": "11f2",
	"./person.png": "962a",
	"./write.png": "9b9f",
	"./图片2.png": "3a18"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ee2";